import apiCallMiddleware from "./api";
import * as helperMethods from "./helpers";
import * as constantsImport from "./constants";
import reducer from "./reducer";
import * as apiSelectors from "./selectors";
import Button from "./components/Button";
import ErrorFeedback from "./components/ErrorFeedback";
import * as actions from "./actions";

export const constants = constantsImport;

export const components = {
	Button,
	ErrorFeedback
};

export const helpers = helperMethods;

export const selectors = apiSelectors;

const api = {
	components,
	middleware: apiCallMiddleware,
	reducer,
	helpers,
	selectors: apiSelectors,
	constants,
	actions
};

export default api;
